import { Component, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { initLenis, scrollTop } from "@/lib/scroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Tracking from "@/pages/Tracking";
import Contact from "@/pages/Contact";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
          <p>Something went wrong. Please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollTop();
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App bg-background text-foreground">
      <BrowserRouter>
        <ErrorBoundary>
          <ScrollManager />
          <Navbar />
          <main className="pt-[72px] md:pt-[108px]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/tracking" element={<Tracking />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
